import * as React from 'react';
import { PonderaModal } from './inclinationmodals';

interface PrivacyPolicyProps {
    nolink?: boolean;
    modalVisible?: boolean;
    cb?: any;
}

interface PrivacyPolicyState {
    modalVisible: boolean;
}

export class PrivacyPolicy extends React.Component<PrivacyPolicyProps, PrivacyPolicyState> {
    constructor(props: PrivacyPolicyProps) {
        super(props);

        this.state = {
            modalVisible: false
        };
    }

    showModal = () => {
        this.setState({modalVisible: true});
    }

    hideModal = () => {
        this.setState({modalVisible: false});
        if (this.props.cb) {
            this.props.cb();
        }
    }

    public render() {
        var content = (
            <div>
                <div>
                    We value your privacy and, unless otherwise stated in our Privacy Policy, will not sell or share your personal information with third parties without your consent.  A brief overview of our data collection and use policies follows.
                </div>
                <div>
                    We collect the following information:
                </div>
                <ul>
                    <li>
                        Personal information that you provide us on a voluntary basis.
                    </li>
                    <li>
                        Information that your browser routinely shares with websites.
                    </li>
                    <li>
                        Information that your mobile device shares when you access the site from a mobile device.
                    </li>
                </ul>

                <div>
                We use and disclose the information we collect for the following purposes:
                </div>
                <ul>
                    <li>
                    To create and maintain your account.
                    </li>
                    <li>
                    To provide you and/or your employer with information based on your responses to our assessment tools.
                    </li>
                    <li>
                    To help us improve our Site, understand its users and their preferences, and to market our services.
                    </li>
                    <li>
                    To protect our business interests or the rights of others, when required by law, to cooperate with law enforcement, or in connection with the sale or merger of all or part of our business.
                    </li>
                </ul>

                <div>
                The Site uses the following tracking technologies:
                </div>
                <ul>
                    <li>
                    Cookies and other similar technology track movement across our website and keep track of our users and their preferences.
                    </li>
                </ul>

                <div>
                Other details about our practices:
                </div>
                <ul>
                    <li>
                    Although the Site may contain links to other websites, this policy applies only to websites owned and operated by Pondera.
                    </li>
                    <li>
                    We use your personal information only for the purposes for which it is collected and consistent with this policy, and we retain your information only as long as permitted by applicable law.
                    </li>
                    <li>
                    We may update this policy from time to time, but we will allow you to opt in to any material changes in how we use your previously collected personal information.
                    </li>
                </ul>
            </div>
        );
        return (
            <React.Fragment>
                {!this.props.nolink && <a href="#" onClick={this.showModal}>Privacy Policy</a>}
                <PonderaModal show={(this.props.nolink && this.props.modalVisible) || this.state.modalVisible} onHide={this.hideModal} title="Privacy Policy" content={''} complexContent={content} simpleTitle={true} />
            </React.Fragment>    
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/PrivacyPolicy.tsx